import ApplicationController from "./application_controller";


export default class extends ApplicationController {
    static targets = [ 'list', 'form', 'attributeList', 'attributeItem' ]

    connect() {
        // Controller connected
    }

    submitForm() {
        // Formular automatisch absenden
        this.element.requestSubmit();
    }

    selectAll() {
        // Alle Checkboxen in der Liste auswählen
        const checkboxes = this.element.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.checked = true;
        });
        
        // Formular automatisch absenden
        this.submitForm();
    }

    filterAttributes(event) {
        const searchTerm = event.target.value.toLowerCase().trim();
        
        if (this.hasAttributeItemTarget) {
            this.attributeItemTargets.forEach(item => {
                const attributeName = item.dataset.attributeName || '';
                const attributeLabel = item.dataset.attributeLabel || '';
                
                const matchesName = attributeName.toLowerCase().includes(searchTerm);
                const matchesLabel = attributeLabel.toLowerCase().includes(searchTerm);
                
                if (matchesName || matchesLabel) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });
        }
    }

    clearSearch() {
        const searchInput = this.element.querySelector('input[placeholder*="durchsuchen"]');
        if (searchInput) {
            searchInput.value = '';
            searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
        
        // Alle Items wieder anzeigen
        if (this.hasAttributeItemTarget) {
            this.attributeItemTargets.forEach(item => {
                item.style.display = 'block';
            });
        }
    }

}
